import React, { Component } from 'react';
import Container from '../Container';
import styles from './style.module.css';
import { Body2, H4, Span } from '../Typography';
import { CONTACT_DATA, OTHER_LINKS } from '../../mock/footerData';
class Footer extends Component {
  render() {
    return (
      <footer className={styles.footer}>
        <div className={styles.top__footer}>
          <Container>
            <div className={styles.row}>
              <div className={styles.col__left}>
                <a
                  href='/'
                  className={styles.footer__logo}>
                  <img
                    src='/assets/Logo.png'
                    alt='logo'
                  />
                  <H4>Golden View Dine</H4>
                </a>
                <Body2>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Sollicitudin
                </Body2>
                <ul className={styles.so__icon}>
                  <li>
                    <a href={CONTACT_DATA.instagramUrl}>
                      <svg
                        width='18'
                        height='18'
                        viewBox='0 0 18 18'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M9.00081 0.466797C6.68327 0.466797 6.39243 0.47693 5.48219 0.518353C4.57374 0.559953 3.95364 0.703777 3.41106 0.914802C2.84981 1.13276 2.37372 1.42432 1.8994 1.89881C1.42473 2.37313 1.13317 2.84922 0.914502 3.41029C0.702944 3.95305 0.558942 4.57333 0.518053 5.48143C0.477342 6.39166 0.466675 6.68268 0.466675 9.00022C0.466675 11.3178 0.476986 11.6077 0.518231 12.5179C0.560009 13.4264 0.703833 14.0465 0.914679 14.5891C1.13282 15.1503 1.42437 15.6264 1.89887 16.1007C2.37301 16.5754 2.8491 16.8677 3.40999 17.0856C3.95293 17.2967 4.57321 17.4405 5.48148 17.4821C6.39171 17.5235 6.68238 17.5336 8.99974 17.5336C11.3175 17.5336 11.6074 17.5235 12.5176 17.4821C13.4261 17.4405 14.0469 17.2967 14.5898 17.0856C15.1509 16.8677 15.6263 16.5754 16.1004 16.1007C16.5751 15.6264 16.8667 15.1503 17.0853 14.5893C17.2951 14.0465 17.4391 13.4262 17.4818 12.5181C17.5227 11.6079 17.5333 11.3178 17.5333 9.00022C17.5333 6.68268 17.5227 6.39184 17.4818 5.4816C17.4391 4.57315 17.2951 3.95306 17.0853 3.41047C16.8667 2.84922 16.5751 2.37313 16.1004 1.89881C15.6258 1.42414 15.1511 1.13258 14.5893 0.914802C14.0453 0.703777 13.4249 0.559953 12.5164 0.518353C11.6062 0.47693 11.3164 0.466797 8.99814 0.466797H9.00081ZM8.23525 2.00457C8.46245 2.00421 8.71597 2.00457 9.00077 2.00457C11.2792 2.00457 11.5492 2.01274 12.449 2.05363C13.281 2.09168 13.7326 2.2307 14.0334 2.3475C14.4316 2.50217 14.7155 2.68706 15.014 2.98573C15.3127 3.2844 15.4976 3.56885 15.6526 3.96708C15.7694 4.26752 15.9086 4.71908 15.9464 5.55109C15.9873 6.45066 15.9962 6.72088 15.9962 8.99824C15.9962 11.2756 15.9873 11.5458 15.9464 12.4454C15.9084 13.2774 15.7694 13.729 15.6526 14.0294C15.4979 14.4276 15.3127 14.7112 15.014 15.0097C14.7153 15.3084 14.4318 15.4932 14.0334 15.6479C13.7329 15.7652 13.281 15.9039 12.449 15.942C11.5494 15.9828 11.2792 15.9917 9.00077 15.9917C6.72217 15.9917 6.45212 15.9828 5.55256 15.942C4.72055 15.9036 4.26899 15.7645 3.96801 15.6477C3.56978 15.4931 3.28533 15.3082 2.98666 15.0095C2.68799 14.7108 2.5031 14.4271 2.34808 14.0287C2.23128 13.7282 2.09208 13.2767 2.05421 12.4447C2.01332 11.5451 2.00514 11.2749 2.00514 8.99611C2.00514 6.71733 2.01332 6.44852 2.05421 5.54896C2.09226 4.71695 2.23128 4.26539 2.34808 3.96459C2.50275 3.56636 2.68799 3.28191 2.98666 2.98324C3.28533 2.68457 3.56978 2.49968 3.96801 2.34466C4.26881 2.22732 4.72055 2.08866 5.55256 2.05043C6.33977 2.01488 6.64484 2.00421 8.23525 2.00243V2.00457ZM13.5558 3.42147C12.9905 3.42147 12.5318 3.87961 12.5318 4.44513C12.5318 5.01047 12.9905 5.46914 13.5558 5.46914C14.1212 5.46914 14.5799 5.01047 14.5799 4.44513C14.5799 3.87979 14.1212 3.42147 13.5558 3.42147ZM9.00082 4.61793C6.58071 4.61793 4.61855 6.58008 4.61855 9.0002C4.61855 11.4203 6.58071 13.3816 9.00082 13.3816C11.4209 13.3816 13.3824 11.4203 13.3824 9.0002C13.3824 6.58008 11.4209 4.61793 9.00082 4.61793ZM9.00079 6.15572C10.5717 6.15572 11.8453 7.42916 11.8453 9.0002C11.8453 10.5711 10.5717 11.8447 9.00079 11.8447C7.42975 11.8447 6.15632 10.5711 6.15632 9.0002C6.15632 7.42916 7.42975 6.15572 9.00079 6.15572Z'
                          fill='white'
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href={CONTACT_DATA.twitterUrl}>
                      <svg
                        width='16'
                        height='14'
                        viewBox='0 0 16 14'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M7.5208 4.0051L7.55438 4.55873L6.99479 4.49094C4.95791 4.23107 3.17843 3.34977 1.66756 1.86964L0.928908 1.13523L0.73865 1.67757C0.33575 2.88653 0.593158 4.16328 1.43253 5.02198C1.8802 5.49653 1.77948 5.56432 1.00725 5.28185C0.73865 5.19146 0.503625 5.12367 0.481242 5.15757C0.4029 5.23666 0.6715 6.26484 0.884142 6.67159C1.17513 7.23653 1.76828 7.79016 2.4174 8.11782L2.96579 8.37769L2.31668 8.38899C1.68994 8.38899 1.66756 8.40029 1.73471 8.63756C1.95854 9.37198 2.84268 10.1516 3.82755 10.4906L4.52143 10.7278L3.91708 11.0894C3.02175 11.6091 1.96973 11.9029 0.917717 11.9255C0.414092 11.9368 0 11.982 0 12.0159C0 12.1289 1.36538 12.7616 2.15999 13.0102C4.54382 13.7446 7.37531 13.4282 9.50173 12.1741C11.0126 11.2815 12.5235 9.50756 13.2286 7.79016C13.6091 6.87497 13.9896 5.20276 13.9896 4.40055C13.9896 3.88081 14.0232 3.81302 14.6499 3.19159C15.0192 2.83003 15.3662 2.43458 15.4333 2.32159C15.5452 2.10692 15.534 2.10692 14.9633 2.299C14.012 2.63796 13.8777 2.59276 14.3477 2.08432C14.6947 1.72276 15.1088 1.06744 15.1088 0.875359C15.1088 0.841463 14.9409 0.897957 14.7506 0.999645C14.5492 1.11263 14.1015 1.28211 13.7658 1.3838L13.1614 1.57588L12.613 1.20302C12.3108 0.999645 11.8856 0.773671 11.6617 0.705879C11.0909 0.547697 10.218 0.570295 9.70318 0.751074C8.30422 1.25952 7.42008 2.57016 7.5208 4.0051Z'
                          fill='white'
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href={CONTACT_DATA.instagramUrl}>
                      <svg
                        width='18'
                        height='13'
                        viewBox='0 0 18 13'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          fillRule='evenodd'
                          clipRule='evenodd'
                          d='M15.6677 0.49952C16.4021 0.70103 16.9804 1.29478 17.1767 2.04878C17.5333 3.41533 17.5333 6.26663 17.5333 6.26663C17.5333 6.26663 17.5333 9.11784 17.1767 10.4845C16.9804 11.2385 16.4021 11.8322 15.6677 12.0338C14.3369 12.4 9.00001 12.4 9.00001 12.4C9.00001 12.4 3.66309 12.4 2.33218 12.0338C1.59783 11.8322 1.0195 11.2385 0.823232 10.4845C0.466675 9.11784 0.466675 6.26663 0.466675 6.26663C0.466675 6.26663 0.466675 3.41533 0.823232 2.04878C1.0195 1.29478 1.59783 0.70103 2.33218 0.49952C3.66309 0.133301 9.00001 0.133301 9.00001 0.133301C9.00001 0.133301 14.3369 0.133301 15.6677 0.49952ZM7.40002 3.86658V9.19991L11.6667 6.53335L7.40002 3.86658Z'
                          fill='white'
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
              <div className={styles.col__center}>
                <H4>Other Links</H4>
                <ul className={styles.footer__links}>
                  {OTHER_LINKS.map((itemLink)=>{
                    return (
                      <li key={itemLink.id}>
                        <a href={itemLink.href}>{itemLink.label}</a>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className={styles.col__right}>
                <H4>Contact Us</H4>
                <ul className={styles.footer__contact}>
                  <li>
                    <a href={`mailto:${CONTACT_DATA.email}`}>
                      <svg
                        width='20'
                        height='20'
                        viewBox='0 0 28 22'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M27 0H1C0.446875 0 0 0.446875 0 1V21C0 21.5531 0.446875 22 1 22H27C27.5531 22 28 21.5531 28 21V1C28 0.446875 27.5531 0 27 0ZM24.475 3.40312L14.6156 11.075C14.3719 11.2656 14.0312 11.2656 13.7875 11.075L3.925 3.40312C3.88782 3.37443 3.86055 3.33483 3.84702 3.28986C3.83348 3.24489 3.83435 3.19681 3.84951 3.15236C3.86467 3.10792 3.89336 3.06933 3.93156 3.042C3.96975 3.01468 4.01554 2.99999 4.0625 3H24.3375C24.3845 2.99999 24.4303 3.01468 24.4684 3.042C24.5066 3.06933 24.5353 3.10792 24.5505 3.15236C24.5656 3.19681 24.5665 3.24489 24.553 3.28986C24.5394 3.33483 24.5122 3.37443 24.475 3.40312Z'
                          fill='#A08040'
                        />
                      </svg>
                      <Span>{CONTACT_DATA.email}</Span>
                    </a>
                  </li>
                  <li>
                    <svg
                      width='20'
                      height='20'
                      viewBox='0 0 22 28'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M11 0C8.08367 0.00344047 5.28778 1.16347 3.22563 3.22563C1.16347 5.28778 0.00344073 8.08367 2.58793e-07 11C-0.00349263 13.3832 0.774981 15.7018 2.216 17.6C2.216 17.6 2.516 17.995 2.565 18.052L11 28L19.439 18.047C19.483 17.994 19.784 17.6 19.784 17.6L19.785 17.597C21.2253 15.6996 22.0034 13.3821 22 11C21.9966 8.08367 20.8365 5.28778 18.7744 3.22563C16.7122 1.16347 13.9163 0.00344047 11 0ZM11 15C10.2089 15 9.43552 14.7654 8.77772 14.3259C8.11992 13.8864 7.60723 13.2616 7.30448 12.5307C7.00173 11.7998 6.92252 10.9956 7.07686 10.2196C7.2312 9.44372 7.61216 8.73098 8.17157 8.17157C8.73098 7.61216 9.44372 7.2312 10.2196 7.07686C10.9956 6.92252 11.7998 7.00173 12.5307 7.30448C13.2616 7.60723 13.8864 8.11992 14.3259 8.77772C14.7654 9.43552 15 10.2089 15 11C14.9987 12.0605 14.5768 13.0771 13.827 13.827C13.0771 14.5768 12.0605 14.9987 11 15Z'
                        fill='#A08040'
                      />
                    </svg>
                    <Span>{CONTACT_DATA.location}</Span>
                  </li>
                  <li>
                    <a href={`tel:${CONTACT_DATA.phone}`}>
                      <svg
                        width='20'
                        height='20'
                        viewBox='0 0 27 26'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          d='M18.33 18.48L20.57 16.24C20.8717 15.9421 21.2534 15.7381 21.6688 15.6529C22.0842 15.5677 22.5154 15.6049 22.91 15.76L25.64 16.85C26.0388 17.0119 26.3808 17.2882 26.6228 17.6441C26.8648 18.0001 26.9961 18.4197 27 18.85V23.85C26.9977 24.1428 26.9361 24.4321 26.8191 24.7005C26.702 24.9688 26.5318 25.2107 26.3188 25.4116C26.1058 25.6125 25.8543 25.7682 25.5796 25.8693C25.3048 25.9704 25.0124 26.0149 24.72 26C5.59 24.81 1.73 8.61004 1 2.41004C0.966113 2.10558 0.997075 1.79739 1.09085 1.50575C1.18462 1.21411 1.33908 0.945633 1.54407 0.717977C1.74905 0.49032 1.99992 0.308646 2.28016 0.184905C2.5604 0.0611637 2.86366 -0.00183916 3.17 4.0869e-05H8C8.43101 0.00131666 8.85178 0.131508 9.2082 0.37387C9.56461 0.616232 9.84037 0.959681 10 1.36004L11.09 4.09004C11.2503 4.48311 11.2911 4.91468 11.2075 5.33085C11.124 5.74702 10.9196 6.12934 10.62 6.43004L8.38 8.67004C8.38 8.67004 9.67 17.4 18.33 18.48Z'
                          fill='#A08040'
                        />
                      </svg>
                      <Span>{CONTACT_DATA.phone}</Span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </Container>
        </div>
        <div className={styles.newsletter__footer}>
          <H4>
            <svg
              width='32'
              height='32'
              viewBox='0 0 32 32'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M2 6L16 16L30 6M2 26H30V6H2V26Z'
                stroke='#A08040'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
            <span>Subscribe to our Newsletter</span>
          </H4>
          <form action=''>
            <input
              type='email'
              placeholder='Your Email id'
              required
            />
            <button type='submit'>Subscribe</button>
          </form>
        </div>
        <div className={styles.bottom__footer}>
          <Body2>
            Copyright © 2022 <a href='/'>Golden Dine website</a>
          </Body2>
          <Body2>All rights reserved</Body2>
        </div>
      </footer>
    );
  }
}

export default Footer;
